// test144
(144 && 0);
